import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {ModalOptions} from '@ionic/core';
import {InsightsFilterComponent} from '../insights-filter/insights-filter.component';
import {copy, isDefined} from '../../../../commons/utils';
import {PersistedFilter} from '../../../../domain/persisted-filter';
import {PositionOverviewFilter} from '../../../../domain/filter/position-overview-filter';
import {ModalController, IonicModule} from '@ionic/angular';
import {LocalStorageService} from '../../../../services/local-storage/local-storage.service';
import {PositionOverviewComponent} from '../../insights-modal/position-overview/position-overview.component';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-insights-header',
  imports: [IonicModule, TranslateModule],
  templateUrl: './insights-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./insights-header.component.scss']
})
export class InsightsHeaderComponent {
  @Input() isTradingVolumeSelected: boolean;
  @Input() positionOverviewFilter: PositionOverviewFilter;
  @Output() readonly onFilterClosed = new EventEmitter<PositionOverviewFilter>();

  private isModalVisible = false;
  private modalObject: HTMLIonModalElement;

  constructor(private readonly localStorageService: LocalStorageService,
              private readonly modalController: ModalController) {
  }

  async openFilters(): Promise<void> {
    const filtersModalOptions: ModalOptions = {
      component: InsightsFilterComponent,
      componentProps: {
        positionOverviewFilter: copy(this.positionOverviewFilter)
      }
    };

    if (!this.isModalVisible) {
      this.isModalVisible = true;
      this.modalObject = await this.modalController.create(filtersModalOptions);
      this.modalObject.onDidDismiss().then(modalData => {
        if (isDefined(modalData.data)) {
          const positionOverviewFilter = modalData.data.positionOverviewFilter;
          const persistedFilter: PersistedFilter<PositionOverviewFilter> = {
            filter: positionOverviewFilter,
            timeStamp: new Date().toString()
          };
          this.localStorageService.setItem(PositionOverviewComponent.FILTER_KEY, persistedFilter);
          this.onFilterClosed.emit(positionOverviewFilter);
        }
        this.isModalVisible = false;
      });
      await this.modalObject.present();
    }
  }
}
